import React, { useCallback, useMemo } from 'react';
import { Box, Button, Card } from './core';
import { networkSetup } from '@sc1/common/utils';
import { toast, useWeb3React } from '@sc1/common';
import { IChain } from '@sc1/common/utils/constants';
import { ConnectWallet } from './ConnectWallet';
import { getProviderInfo, IProviderInfo } from 'web3modal';

export const NetworkPrompt = ({
  chain,
}: {
  chain: IChain;
}): JSX.Element | null => {
  const { library, active } = useWeb3React();

  const switchNetwork = useCallback(async () => {
    const { error } = await networkSetup(chain, library);
    if (error) toast.send.error(error);
  }, [chain, library, networkSetup]);

  const providerInfo = useMemo(
    (): IProviderInfo | undefined =>
      library?.provider && getProviderInfo(library.provider),
    [library?.provider]
  );
  const isWalletConnect = providerInfo?.id === 'walletconnect';
  return (
    <Card
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ my: 3 }}>
        {active ? (
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ my: 3 }}>This vault is on the {chain} network</Box>
            {!!isWalletConnect && (
              <Box>Switch your network to {chain} to interact</Box>
            )}
            {!isWalletConnect && (
              <Button
                sx={{ textTransform: 'capitalize' }}
                onClick={switchNetwork}
              >
                Switch to {chain}
              </Button>
            )}
          </Box>
        ) : (
          <ConnectWallet />
        )}
      </Box>
    </Card>
  );
};
